/*
 * STRYD Offers
 * 1. <stryd-offer> product-page widget: builds a bundle / pack and adds it to the cart in one request.
 * 2. Free gift engine: keeps exactly one free gift in the cart while the cart qualifies, removes it when not.
 * Prices are never set here. Native Shopify automatic discounts price everything at cart and checkout.
 */
(function () {
  'use strict';

  var CFG = window.STRYD_OFFERS || {};
  CFG.isTester = !!CFG.customerId && (CFG.testCustomerIds || []).map(String).indexOf(String(CFG.customerId)) > -1;
  var OWN = { 'X-Stryd-Offers': '1' }; // marks our own cart requests so the fetch hook ignores them
  var nativeFetch = window.fetch.bind(window);

  function money(cents) {
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  function cartRequest(path, body) {
    return nativeFetch(path, {
      method: body ? 'POST' : 'GET',
      headers: Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json' }, OWN),
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Cart error');
        return j;
      });
    });
  }

  function refreshCartUI(open) {
    var api = window.essentialCartApi;
    if (location.pathname === '/cart' && !open) { location.reload(); return Promise.resolve(); }
    if (api && api.refreshCart) {
      return Promise.resolve(api.refreshCart()).then(function () {
        if (open && api.openCart) api.openCart();
      });
    }
    if (location.pathname === '/cart') { location.reload(); return Promise.resolve(); }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    if (open) location.href = '/cart';
    return Promise.resolve();
  }

  /* ---------------------------------------------------------------- widget */

  class StrydOffer extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('.product__info-container, .product__info-wrapper, product-info') || document.body;
      this.fine = this.querySelector('.stryd-offer__fine');
      this.addEventListener('change', this.onChange.bind(this));
      this.querySelector('[data-cta]').addEventListener('click', this.add.bind(this));
      this.buildSticky();
      this.update();
    }

    // Sticky bundle bar (2026-10-24): while a bundle is selected, replaces Essential's sticky "Add to cart" bar
    // (which only knows the single product) and appears once our own button scrolls out of view.
    // Shows what will be added, so the shopper never adds sizes they haven't seen. One per page.
    buildSticky() {
      if (document.querySelector('.stryd-sticky')) return;
      var bar = document.createElement('div');
      bar.className = 'stryd-sticky';
      bar.innerHTML = '<div class="stryd-sticky__inner"><div class="stryd-sticky__info">' +
        '<p class="stryd-sticky__title"><span data-s-title></span><span class="stryd-offer__badge" data-s-badge></span></p>' +
        '<p class="stryd-sticky__picks" data-s-picks></p></div>' +
        '<button type="button" class="stryd-offer__cta stryd-sticky__btn"><span data-s-label></span><span data-s-price></span></button></div>';
      document.body.appendChild(bar);
      this.sticky = bar;
      var self = this;
      bar.querySelector('button').addEventListener('click', function () { self.add(true); });
      this.ctaInView = true;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          // "out of view" only once it has scrolled past or sits below the fold, not while hidden (zero size)
          var e = entries[0];
          self.ctaInView = e.isIntersecting || e.boundingClientRect.height === 0;
          self.showSticky();
        }).observe(this.querySelector('[data-cta]'));
      }
    }

    showSticky() {
      if (!this.sticky) return;
      var on = document.body.classList.contains('stryd-bundle-on') && !this.ctaInView;
      this.sticky.classList.toggle('is-on', on);
      document.body.classList.toggle('stryd-sticky-on', on);
    }

    fillSticky(opt, panel, price) {
      if (!this.sticky) return;
      var q = this.sticky.querySelector.bind(this.sticky);
      var label = opt.querySelector('.stryd-offer__label');
      var badge = opt.querySelector('.stryd-offer__badge');
      q('[data-s-title]').textContent = label ? label.textContent : '';
      q('[data-s-badge]').textContent = badge ? badge.textContent : '';
      q('[data-s-badge]').hidden = !badge;
      var picks = [];
      panel.querySelectorAll('[data-slot]').forEach(function (slot) {
        var sel = Array.prototype.find.call(slot.querySelectorAll('[data-variant-select]'), function (s) { return !s.hidden; });
        var name = slot.querySelector('.stryd-offer__slot-label');
        if (sel && sel.selectedIndex > -1) picks.push((name ? name.textContent.trim() + ': ' : '') + sel.options[sel.selectedIndex].text.trim());
      });
      this.querySelectorAll('[data-addon]').forEach(function (a) {
        if (a.querySelector('[data-addon-check]').checked) {
          var s = a.querySelector('[data-variant-select]');
          picks.push('+ ' + (a.querySelector('.stryd-offer__addon-text').childNodes[1] || {}).textContent.trim().replace(/^Add (the )?/i, '').replace(/ for \$.*$/, '') +
            (s && s.selectedIndex > -1 ? ': ' + s.options[s.selectedIndex].text.trim() : ''));
        }
      });
      q('[data-s-picks]').textContent = picks.join('  ·  ');
      q('[data-s-label]').textContent = this.querySelector('[data-cta-label]').textContent;
      q('[data-s-price]').textContent = ' ' + money(price);
    }

    selected() {
      var r = this.querySelector('input[type=radio]:checked');
      return r ? r.closest('.stryd-offer__option') : null;
    }

    onChange(e) {
      var slot = e.target.closest('[data-slot]');
      var ps = e.target.closest('[data-product-select]');
      if (ps) {
        slot.querySelectorAll('[data-variant-select]').forEach(function (s) {
          s.hidden = s.dataset.for !== ps.value;
        });
      }
      if (slot) this.thumb(slot);
      this.update();
    }

    // show the photo of the product / colour currently chosen in this slot
    thumb(slot) {
      var img = slot.querySelector('[data-thumb]');
      var sel = Array.prototype.find.call(slot.querySelectorAll('[data-variant-select]'), function (s) { return !s.hidden; });
      var opt = sel && sel.options[sel.selectedIndex];
      if (img && opt && opt.dataset.img) img.src = opt.dataset.img;
    }

    update() {
      var opt = this.selected();
      var single = !opt || !!opt.querySelector('[data-single]');
      this.querySelectorAll('.stryd-offer__option').forEach(function (o) {
        o.classList.toggle('is-selected', o === opt);
      });
      // Bundle chosen: hide the theme's own quantity + Add to cart, show ours. Single: the reverse.
      this.info.classList.toggle('stryd-offer-active', !single);
      document.body.classList.toggle('stryd-bundle-on', !single);
      var cta = this.querySelector('[data-cta]');
      var err = this.querySelector('[data-error]');
      var addons = this.querySelectorAll('[data-addon]');
      cta.hidden = single;
      addons.forEach(function (a) { a.hidden = single; });
      // Add-on, button and error sit inside the selected option, right under its size pickers,
      // so the button stays next to the choice. Single piece: they go back to the end of the widget.
      var home = single ? null : opt;
      var self = this;
      Array.prototype.forEach.call(addons, function (a) { if (home) home.appendChild(a); else self.insertBefore(a, self.fine); });
      [cta, err].forEach(function (n) { if (home) home.appendChild(n); else self.insertBefore(n, self.fine); });
      if (!single) {
        var panel = opt.querySelector('[data-panel]');
        var price = parseInt(panel.dataset.price, 10);
        // a ticked add-on (e.g. the Run Cap at $30) is part of what the button adds, so it's part of its price
        addons.forEach(function (a) {
          if (a.querySelector('[data-addon-check]').checked) price += parseInt(a.dataset.addonPrice, 10) || 0;
        });
        this.querySelector('[data-cta-price]').textContent = ' ' + money(price);
        // each bundle option can name its own button ("Add the pair" / "Add the kit")
        var label = this.querySelector('[data-cta-label]');
        if (label && panel.dataset.button) label.textContent = panel.dataset.button;
        this.fillSticky(opt, panel, price);
      }
      this.showSticky();
    }

    lines() {
      var opt = this.selected();
      var offerId = this.dataset.offerId;
      var items = [];
      // only the option's own slots: the add-on (also data-slot, for its photo swap) now sits inside the selected
      // option and is added below only when ticked
      opt.querySelector('[data-panel]').querySelectorAll('[data-slot]').forEach(function (slot) {
        var v = Array.prototype.find.call(slot.querySelectorAll('[data-variant-select]'), function (s) { return !s.hidden; });
        if (v) items.push({ id: Number(v.value), quantity: 1, properties: { _stryd_offer: offerId } });
      });
      this.querySelectorAll('[data-addon]').forEach(function (a) {
        if (a.querySelector('[data-addon-check]').checked) {
          items.push({ id: Number(a.querySelector('[data-variant-select]').value), quantity: 1, properties: { _stryd_offer: offerId } });
        }
      });
      // merge identical variants (e.g. 3 pairs of the same socks) into one line
      var merged = {};
      items.forEach(function (i) {
        if (merged[i.id]) merged[i.id].quantity += 1; else merged[i.id] = i;
      });
      return Object.keys(merged).map(function (k) { return merged[k]; });
    }

    add(fromSticky) {
      var btn = this.querySelector('[data-cta]');
      var sbtn = this.sticky && this.sticky.querySelector('button');
      var err = this.querySelector('[data-error]');
      err.hidden = true;
      [btn, sbtn].forEach(function (b) { if (b) { b.disabled = true; b.classList.add('is-loading'); } });
      cartRequest('/cart/add.js', { items: this.lines() })
        .then(function () { return Gift.sync(); })
        .then(function () { return refreshCartUI(true); })
        .catch(function (e) {
          err.textContent = e.message || 'That combination could not be added. Please check sizes and try again.';
          err.hidden = false;
          // the error shows under the bundle's own button: bring it into view when the sticky bar was used
          if (fromSticky === true) err.scrollIntoView({ behavior: 'smooth', block: 'center' });
        })
        .finally(function () {
          [btn, sbtn].forEach(function (b) { if (b) { b.disabled = false; b.classList.remove('is-loading'); } });
        });
    }
  }
  if (!customElements.get('stryd-offer')) customElements.define('stryd-offer', StrydOffer);

  /* ------------------------------------------------------------ free gift */

  var Gift = (function () {
    var g = CFG.gift;
    var KEY = 'stryd-gift-' + (g ? g.id : '');
    var timer = null;
    // every gift action (check, swap, add back) runs one at a time, so fast clicks can't overlap
    var chain = Promise.resolve();
    function serial(fn) {
      chain = chain.then(fn).catch(function (e) { console.warn('[STRYD Offers]', e); });
      return chain;
    }

    function state() { try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
    function save(s) { try { sessionStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }

    // which sock size suits the cart: Womens when it holds more women's items than men's, otherwise Mens
    function sizeForCart(cart) {
      if (!cart) return null;
      var women = 0, men = 0;
      cart.items.forEach(function (i) {
        if (isGiftLine(i)) return;
        var text = [i.product_type, i.product_title, i.handle].join(' ').toLowerCase();
        if (/wom[ae]n/.test(text)) women += i.quantity;
        else if (/\bmen'?s?\b/.test(text)) men += i.quantity;
      });
      if (women > men) return 'Womens';
      if (men > women) return 'Mens';
      return null;
    }

    // a newly added pair starts as the default colour (White) in the size that suits the cart;
    // the shopper changes it in the popup
    function preferredVariant(cart) {
      var avail = g.variants.filter(function (v) { return v.available; });
      var def = avail.find(function (v) { return v.title === g.defaultVariant; });
      var size = sizeForCart(cart);
      if (size) {
        var sized = avail.filter(function (v) { return v.options.indexOf(size) !== -1; });
        var base = g.variants.find(function (v) { return v.title === g.defaultVariant; });
        // same colour as the default, only the size swapped
        var match = base && sized.find(function (v) {
          return v.options.every(function (o, k) { return o === size || o === base.options[k]; });
        });
        if (match || sized[0]) return match || sized[0];
      }
      if (def) return def;
      return avail.slice().sort(function (a, b) { return b.stock - a.stock; })[0];
    }

    // the gift is its own $0 product, so any line of it counts as the gift
    function isGiftLine(i) { return i.product_id === g.productId; }

    function analyse(cart) {
      var giftLines = cart.items.filter(isGiftLine);
      var qualifying = cart.items.filter(function (i) {
        return !isGiftLine(i) && (g.excludeProductIds || []).indexOf(i.product_id) === -1 && !i.gift_card && i.price > 0;
      });
      var count = qualifying.reduce(function (n, i) { return n + i.quantity; }, 0);
      var subtotal = qualifying.reduce(function (n, i) { return n + i.final_line_price; }, 0);
      return {
        giftLines: giftLines,
        eligible: count >= (g.minItems || 1) && subtotal >= (g.minSubtotal || 0) * 100
      };
    }

    function run() {
      if (!g) return Promise.resolve();
      return serial(check);
    }

    function check() {
      // the gift is a $0 product, so it works for everyone; the notice is only about bundle pricing in test mode
      if (CFG.mode === 'test' && !CFG.isTester) Notice.show();
      var changed = false;
      var st = state();
      return cartRequest('/cart.js').then(function (cart) {
        var a = analyse(cart);
        var steps = Promise.resolve(cart);

        // an emptied cart starts fresh: a gift removed from an earlier cart doesn't block the next one
        if (!a.eligible && !a.giftLines.length) st.declined = false;

        // a failed attempt is tied to who was logged in and expires, so logging in (or 10 minutes) retries
        var who = String(CFG.customerId || 'guest');
        if (st.failed && (st.failed.who !== who || Date.now() - st.failed.at > 600000)) st.failed = null;

        if (!a.eligible && a.giftLines.length) {
          var updates = {};
          a.giftLines.forEach(function (l) { updates[l.key] = 0; });
          steps = cartRequest('/cart/update.js', { updates: updates });
          changed = true;
        } else if (a.eligible && !a.giftLines.length && g.autoAdd && !st.declined && !st.failed) {
          var v = preferredVariant(cart);
          if (v) {
            steps = cartRequest('/cart/add.js', { items: [{ id: v.id, quantity: 1, properties: { _stryd_gift: g.id } }] })
              .then(function () { return cartRequest('/cart.js'); });
            changed = true;
            st.justAdded = true;
          }
        } else if (a.giftLines.length > 1 || (a.giftLines[0] && a.giftLines[0].quantity > 1)) {
          var fix = {};
          a.giftLines.forEach(function (l, i) { fix[l.key] = i === 0 ? 1 : 0; });
          steps = cartRequest('/cart/update.js', { updates: fix });
          changed = true;
        }

        return steps.then(function (c) {
          return changed ? cartRequest('/cart.js') : c;
        }).then(function (c) {
          var after = analyse(c);
          var line = after.giftLines[0];
          // Safety net: never leave a "free" gift in the cart at full price (e.g. test mode, not logged in).
          if (line && line.final_line_price > 0) {
            st.failed = { who: String(CFG.customerId || 'guest'), at: Date.now() };
            st.justAdded = false;
            if (CFG.mode === 'test') console.info('[STRYD Offers] Gift discount not applied (test mode: log in as a test customer). Removing gift line.');
            var u = {}; u[line.key] = 0;
            changed = true;
            return cartRequest('/cart/update.js', { updates: u }).then(function () { line = null; return c; });
          }
          return c;
        }).then(function () {
          return cartRequest('/cart.js');
        }).then(function (c) {
          var fin = analyse(c);
          st.present = fin.giftLines.length > 0;
          st.selfChange = false;
          if (st.present) st.declined = false;
          save(st);
          Note.render(fin, c);
          Savings.update(c);
          if (st.justAdded && st.present) { Note.toast(fin.giftLines[0].variant_id); st.justAdded = false; save(st); }
          if (changed) return refreshCartUI(false);
        });
      });
    }

    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(run, 250);
    }

    function addBack() {
      var st = state(); st.declined = false; st.failed = null; st.selfChange = true; save(st);
      return run();
    }

    // change colour/size of the free pair in ONE cart request (old pair out, new pair in),
    // so the cart is never briefly without the gift
    // only the latest pick matters: rapid changes collapse into a single cart update
    var pendingVariant = null;
    function swap(variantId) {
      pendingVariant = Number(variantId);
      var st0 = state(); st0.variant = pendingVariant; save(st0);
      return serial(function () {
        if (pendingVariant === null) return;
        var variantId = pendingVariant;
        pendingVariant = null;
        return cartRequest('/cart.js').then(function (cart) {
          var lines = cart.items.filter(isGiftLine);
          if (lines.length === 1 && lines[0].variant_id === variantId && lines[0].quantity === 1) return null;
          var u = {};
          var keep = lines.find(function (l) { return l.variant_id === variantId; });
          lines.forEach(function (l) { u[l.key] = l === keep ? 1 : 0; });
          if (!keep) u[variantId] = 1;
          return cartRequest('/cart/update.js', { updates: u });
        }).then(function (res) {
          if (!res) return;
          var st2 = state(); st2.present = true; st2.declined = false; st2.variant = variantId; save(st2);
          if (pendingVariant === null) return refreshCartUI(false); // a newer pick is queued: refresh after that one
        });
      });
    }

    // called by the cart watcher when the shopper's own request (drawer bin / qty 0) removes the gift line
    function markDeclined() { var st = state(); st.declined = true; save(st); }
    function isGiftVariant(id) { return !!g && g.variants.some(function (v) { return String(v.id) === String(id); }); }

    return { sync: run, schedule: schedule, addBack: addBack, swap: swap, config: g, preferredVariant: preferredVariant,
             markDeclined: markDeclined, isGiftVariant: isGiftVariant };
  })();

  /* ------------------------------------- gift popup + cart-page note */

  var Note = (function () {
    var g = CFG.gift;

    function el(tag, cls, text) {
      var e = document.createElement(tag);
      if (cls) e.className = cls;
      if (text) e.textContent = text;
      return e;
    }
    function label(name) { return /^colou?r$/i.test(name) ? 'Colour' : name; }
    function byId(id) { return g.variants.find(function (v) { return v.id === Number(id); }); }

    // square option buttons (Colour: White / Black, Size: Mens / Womens) instead of a dropdown
    function chooser(currentId, thumb) {
      var current = byId(currentId) || Gift.preferredVariant();
      var picked = current ? current.options.slice() : [];
      var wrap = el('div', 'stryd-gift__chooser');
      var rows = [];
      (g.optionNames || []).forEach(function (name, i) {
        var group = el('div', 'stryd-gift__group');
        group.appendChild(el('span', 'stryd-gift__group-label', label(name)));
        var row = el('div', 'stryd-gift__options');
        var values = [];
        g.variants.forEach(function (v) { if (values.indexOf(v.options[i]) === -1) values.push(v.options[i]); });
        values.forEach(function (val) {
          var b = el('button', 'stryd-gift__opt', val);
          b.type = 'button';
          b.dataset.value = val;
          b.addEventListener('click', function () {
            picked[i] = val;
            var target = g.variants.find(function (v) { return v.options.every(function (o, k) { return o === picked[k]; }); });
            if (!target || !target.available) {
              target = g.variants.find(function (v) { return v.available && v.options[i] === val; });
              if (!target) return;
              picked = target.options.slice();
            }
            paint();
            if (thumb && target.image) thumb.src = target.image;
            Gift.swap(target.id);
          });
          row.appendChild(b);
        });
        group.appendChild(row);
        wrap.appendChild(group);
        rows.push(row);
      });
      function paint() {
        rows.forEach(function (row, i) {
          Array.prototype.forEach.call(row.children, function (b) {
            var val = b.dataset.value;
            var on = picked[i] === val;
            var possible = g.variants.some(function (v) {
              return v.available && v.options[i] === val && v.options.every(function (o, k) { return k === i || o === picked[k]; });
            });
            b.classList.toggle('is-on', on);
            b.classList.toggle('is-off', !possible);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        });
      }
      paint();
      return wrap;
    }

    function priceRow() {
      var p = el('p', 'stryd-gift__price');
      if (g.wasPrice) p.appendChild(el('s', null, g.wasPrice));
      p.appendChild(el('span', null, '$0'));
      return p;
    }

    function head(v, eyebrow, heading) {
      var h = el('div', 'stryd-gift__head');
      var img = el('img', 'stryd-gift__thumb');
      img.alt = '';
      img.src = (v && v.image) || '';
      h.appendChild(img);
      var txt = el('div', 'stryd-gift__head-text');
      if (eyebrow) txt.appendChild(el('p', 'stryd-gift__eyebrow', eyebrow));
      txt.appendChild(el('p', 'stryd-gift__heading', heading));
      txt.appendChild(priceRow());
      h.appendChild(txt);
      return { node: h, img: img };
    }

    function render(a) {
      if (!g) return;
      document.querySelectorAll('[data-stryd-gift-note]').forEach(function (mount) {
        mount.innerHTML = '';
        var box = el('div', 'stryd-gift');
        var line = a.giftLines[0];
        if (line) {
          var h = head(byId(line.variant_id), null, g.noteAddedHeading);
          box.appendChild(h.node);
          box.appendChild(el('p', 'stryd-gift__body', g.addedMessage));
          box.appendChild(chooser(line.variant_id, h.img));
        } else {
          box.appendChild(el('p', 'stryd-gift__heading', g.noteHeading));
          box.appendChild(el('p', 'stryd-gift__body', g.noteBody));
          if (a.eligible) {
            var b = el('button', 'stryd-offer__cta', g.addBackLabel);
            b.type = 'button';
            b.addEventListener('click', Gift.addBack);
            box.appendChild(b);
          }
        }
        box.appendChild(el('p', 'stryd-gift__terms', g.terms));
        mount.appendChild(box);
      });
    }

    var currentGiftVariant = null;
    function toast(variantId) {
      currentGiftVariant = variantId || null;
      if (!g) return;
      var old = document.querySelector('.stryd-gift-toast');
      if (old) old.remove();
      // show the pair that is actually in the cart
      var v = byId(currentGiftVariant) || Gift.preferredVariant();
      var t = el('div', 'stryd-gift-toast');
      t.setAttribute('role', 'dialog');
      t.setAttribute('aria-label', g.popupHeading);

      var x = el('button', 'stryd-gift-toast__x');
      x.type = 'button';
      x.setAttribute('aria-label', 'Close');
      x.innerHTML = '&times;';
      x.addEventListener('click', function () { t.remove(); });
      t.appendChild(x);

      var h = head(v, g.popupEyebrow, g.popupHeading);
      t.appendChild(h.node);
      t.appendChild(el('p', 'stryd-gift__body', g.popupBody));
      t.appendChild(chooser(v ? v.id : null, h.img));

      var done = el('button', 'stryd-offer__cta stryd-gift__done', g.doneLabel);
      done.type = 'button';
      done.addEventListener('click', function () { t.remove(); });
      t.appendChild(done);

      document.body.appendChild(t);
      setTimeout(function () { t.classList.add('is-in'); }, 20);
      // stays open until the shopper presses Done or the close button
      dockToDrawer(t);
    }

    // Desktop: sit right next to the cart drawer, just left of it and level with the gift line in the cart, so the
    // colour/size choice is beside the item it changes and the drawer's subtotal and checkout stay clear.
    // Drawer closed: top right, under the cart icon. The drawer usually opens a moment after the gift is added,
    // and can close or scroll while the popup is up, so keep checking until the popup is gone. Phones: CSS bottom sheet.
    function dockToDrawer(t) {
      function place() {
        if (!document.body.contains(t)) { clearInterval(timer); return; }
        if (window.innerWidth < 750) { t.style.right = t.style.top = ''; return; }
        var head = document.querySelector('[data-essential-cart-element="cart-drawer-header"]');
        var panel = head && head.parentElement;
        var r = panel && panel.getBoundingClientRect();
        var open = r && r.width > 0 && r.left < window.innerWidth - 10;
        var right, top;
        if (open) {
          right = window.innerWidth - r.left + 16;
          var gift = Array.prototype.find.call(panel.querySelectorAll('[data-essential-cart-element="cart-drawer-item"]'),
            function (i) { return /^\s*gift:/i.test(i.textContent); });
          top = gift ? gift.getBoundingClientRect().top : head.getBoundingClientRect().bottom + 16;
        } else {
          right = 16;
          var icon = document.querySelector('#cart-icon-bubble');
          top = icon ? icon.getBoundingClientRect().bottom + 12 : 16;
        }
        // keep the whole popup on screen
        top = Math.max(16, Math.min(top, window.innerHeight - t.offsetHeight - 16));
        var wr = Math.round(right) + 'px', wt = Math.round(top) + 'px';
        if (t.style.right !== wr) t.style.right = wr;
        if (t.style.top !== wt) t.style.top = wt;
      }
      var timer = setInterval(place, 200);
      place();
    }

    return { render: render, toast: toast };
  })();

  /* ------------------------------------- cart savings strip (drawer + /cart page) */

  var Savings = (function () {
    var S = CFG.savings || {};
    var g = CFG.gift;
    var compareCache = {};
    var last = null;
    var node = null;

    function el(tag, cls, text) {
      var e = document.createElement(tag);
      if (cls) e.className = cls;
      if (text) e.textContent = text;
      return e;
    }

    // compare-at prices aren't in /cart.js, so read them once per product
    function compareFor(item) {
      if (!compareCache[item.handle]) {
        compareCache[item.handle] = nativeFetch('/products/' + item.handle + '.js', { headers: OWN })
          .then(function (r) { return r.json(); })
          .then(function (p) { var m = {}; (p.variants || []).forEach(function (v) { m[v.id] = v.compare_at_price || 0; }); return m; })
          .catch(function () { return {}; });
      }
      return compareCache[item.handle];
    }

    // Free shipping as a saving: once the cart total (after discounts) reaches the free-shipping minimum,
    // count the Standard rate this cart's weight would otherwise cost (rates from offers.json savings.freeShipping).
    function shippingSaved(cart) {
      var F = S.freeShipping;
      if (!F || !F.rates || !F.rates.length) return 0;
      if (cart.total_price < Math.round((F.minSubtotal || 0) * 100)) return 0;
      var grams = cart.total_weight || 0;
      for (var i = 0; i < F.rates.length; i++) {
        if (grams <= F.rates[i].maxGrams) return Math.round(F.rates[i].price * 100);
      }
      return 0;
    }

    function compute(cart) {
      var byTitle = {}, order = [], gifts = 0, sale = 0;
      return Promise.all(cart.items.map(function (i) {
        if (g && i.product_id === g.productId) { gifts += (g.wasPriceCents || 0) * i.quantity; return null; }
        (i.line_level_discount_allocations || []).forEach(function (d) {
          var t = d.discount_application && d.discount_application.title || 'Discount';
          if (!(t in byTitle)) { byTitle[t] = 0; order.push(t); }
          byTitle[t] += d.amount;
        });
        return compareFor(i).then(function (m) {
          var c = m[i.variant_id] || 0;
          if (c > i.original_price) sale += (c - i.original_price) * i.quantity;
        });
      })).then(function () {
        var rows = order.map(function (t) { return { label: t, amount: byTitle[t] }; });
        (cart.cart_level_discount_applications || []).forEach(function (d) {
          rows.push({ label: d.title, amount: d.total_allocated_amount });
        });
        if (gifts) rows.push({ label: S.giftLabel || 'Free pair of crew socks', amount: gifts });
        if (sale) rows.push({ label: S.saleLabel || 'Sale prices', amount: sale });
        var ship = shippingSaved(cart);
        if (ship) rows.push({ label: (S.freeShipping && S.freeShipping.label) || 'Free shipping', amount: ship });
        rows = rows.filter(function (r) { return r.amount > 0; });
        return { total: rows.reduce(function (n, r) { return n + r.amount; }, 0), rows: rows };
      });
    }

    function build(s) {
      var box = el('div', 'stryd-savings');
      box.setAttribute('data-stryd-savings', '');
      var line = (S.line || "YOU'RE SAVING {amount} ON THIS ORDER").replace('{amount}', money(s.total));
      box.appendChild(el('p', 'stryd-savings__line', line));
      var list = el('ul', 'stryd-savings__rows');
      s.rows.forEach(function (r) {
        var li = el('li');
        li.appendChild(el('span', null, r.label));
        li.appendChild(el('span', null, money(r.amount)));
        list.appendChild(li);
      });
      box.appendChild(list);
      return box;
    }

    // Essential Cart's own plain "Savings" row leaves out the free pair; ours replaces it.
    // Find the label, climb to the row that also holds the amount, and hide that row.
    function hideEssentialSavings(footer) {
      var label = (S.essentialLabel || 'Savings').toLowerCase();
      Array.prototype.forEach.call(footer.querySelectorAll('*'), function (e) {
        if (e.closest('[data-stryd-savings]') || e.textContent.trim().toLowerCase() !== label) return;
        var row = e;
        while (row.parentElement && row.parentElement !== footer && !/\$/.test(row.textContent)) row = row.parentElement;
        if (/\$/.test(row.textContent) && !/subtotal/i.test(row.textContent) && !row.querySelector('[data-stryd-savings]')) {
          row.style.setProperty('display', 'none', 'important');
        }
      });
    }

    // Shipping row above Secure checkout, so the cost isn't first seen at the last checkout step.
    // AU Standard rate for this cart's weight (same rates as shippingSaved), or "Free" at the free-shipping minimum.
    // AU visitors only: international is a different flat rate.
    var shipNode = null;
    // Secure checkout button amount: payBase = the cart total Essential prints (as of our last /cart.js read),
    // payTotal = what the shopper pays (payBase + this shipping, or payBase when shipping is free). null = hands off.
    var payBase = null, payTotal = null;
    function shipRow(cart) {
      var F = S.freeShipping;
      var country = (window.Shopify && window.Shopify.country) || 'AU';
      payBase = payTotal = null;
      if (!F || !F.rates || !F.rates.length || country !== 'AU' || !cart.item_count) return null;
      payBase = payTotal = cart.total_price;
      var value;
      if (cart.total_price >= Math.round((F.minSubtotal || 0) * 100)) {
        value = F.rowFree || 'Free';
      } else {
        var grams = cart.total_weight || 0;
        var rate = F.rates.find(function (r) { return grams <= r.maxGrams; });
        if (!rate) { payBase = payTotal = null; return null; } // over the heaviest bracket: let checkout quote it
        var cents = Math.round(rate.price * 100);
        value = money(cents);
        payTotal = cart.total_price + cents;
      }
      var row = el('div', 'stryd-ship');
      row.setAttribute('data-stryd-ship', '');
      var line = el('div', 'stryd-ship__line');
      line.appendChild(el('span', 'stryd-ship__label', F.rowLabel || 'Shipping (AU)'));
      line.appendChild(el('span', 'stryd-ship__value', value));
      row.appendChild(line);
      // Under the free-shipping minimum: a thin progress line and the exact amount still to go, right above
      // the button (the app's own bar at the top of the drawer scrolls away once the cart has a few items).
      var min = Math.round((F.minSubtotal || 0) * 100);
      if (payTotal !== payBase && min > cart.total_price) {
        var more = el('div', 'stryd-ship__more');
        var bar = el('span', 'stryd-ship__bar');
        var fill = el('span', 'stryd-ship__fill');
        fill.style.width = Math.max(4, Math.min(100, Math.round(cart.total_price / min * 100))) + '%';
        bar.appendChild(fill);
        more.appendChild(bar);
        more.appendChild(el('span', 'stryd-ship__to-go',
          (F.rowMore || 'Add {amount} for free shipping').replace('{amount}', fmt2(min - cart.total_price))));
        row.appendChild(more);
      }
      return row;
    }
    function placeShip(footer) {
      var mine = footer.querySelector('[data-stryd-ship]');
      if (mine && mine === shipNode) return;
      if (mine) mine.remove();
      var btn = footer.querySelector('[data-essential-cart-element="cart-drawer-checkout-button"]');
      if (!shipNode || !btn) return;
      var anchor = btn.closest('form') && footer.contains(btn.closest('form')) ? btn.closest('form') : btn;
      anchor.parentElement.insertBefore(shipNode, anchor);
    }

    // Essential prints the item total on the button ("Secure checkout · $39.60"); with shipping now shown
    // just above it, swap that amount for what the shopper will pay (items + shipping).
    // Only rewrite an amount we can account for: Essential's total for the cart we last read, or a number we wrote.
    // Any other amount means the cart changed before our re-read (Essential redrew first), so re-read the cart and
    // leave Essential's number alone meanwhile. Never overwrite with a total from an older cart.
    var PRICE = /\$[\d,]+\.\d{2}/;
    var written = {}, lastUnknown = null;
    function fmt2(cents) { return '$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function fixButtonTotal(footer) {
      var btn = footer.querySelector('[data-essential-cart-element="cart-drawer-checkout-button"]');
      if (!btn) return;
      var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT), node = null, m = null;
      for (var n = walker.nextNode(); n; n = walker.nextNode()) {
        m = n.nodeValue.match(PRICE);
        if (m) { node = n; break; }
      }
      if (!node) return;
      var cur = m[0];
      var want = payBase === null ? null : fmt2(payTotal);
      if (cur === want) { lastUnknown = null; return; }
      if (want !== null && (cur === fmt2(payBase) || written[cur])) {
        written[want] = true;
        node.nodeValue = node.nodeValue.replace(PRICE, want);
        var aria = btn.getAttribute('aria-label');
        if (aria && PRICE.test(aria)) btn.setAttribute('aria-label', aria.replace(PRICE, want));
        lastUnknown = null;
      } else if (cur !== lastUnknown) {
        // an amount we didn't expect (cart changed elsewhere, or one we wrote is now out of date): re-read once
        lastUnknown = cur;
        Gift.schedule();
      }
    }

    function place() {
      var show = last && last.total > 0;
      var footer = document.querySelector('[data-essential-cart-element="cart-drawer-footer"]');
      if (footer) { placeShip(footer); fixButtonTotal(footer); }
      if (footer) {
        var mine = footer.querySelector('[data-stryd-savings]');
        if (show && (!mine || mine !== node)) {
          if (mine) mine.remove();
          footer.insertBefore(node, footer.firstChild);
        } else if (!show && mine) {
          mine.remove();
        }
        hideEssentialSavings(footer);
      }
      // /cart page: above the free-gift note
      document.querySelectorAll('[data-stryd-gift-note]').forEach(function (mount) {
        var prev = mount.parentElement.querySelector(':scope > [data-stryd-savings-page]');
        if (prev) prev.remove();
        if (show) {
          var copy = build(last);
          copy.setAttribute('data-stryd-savings-page', '');
          copy.removeAttribute('data-stryd-savings');
          copy.classList.add('stryd-savings--page');
          mount.parentElement.insertBefore(copy, mount);
        }
      });
    }

    function update(cart) {
      shipNode = shipRow(cart);
      return compute(cart).then(function (s) {
        last = s;
        node = s.total > 0 ? build(s) : null;
        place();
      });
    }

    // Essential re-renders its drawer (and its own savings row) as the cart loads;
    // after every redraw, put our strip back and hide its row again
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      var footer = document.querySelector('[data-essential-cart-element="cart-drawer-footer"]');
      if (!footer) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        if (last && last.total > 0 && !footer.querySelector('[data-stryd-savings]')) place();
        else hideEssentialSavings(footer);
        if (shipNode && !footer.querySelector('[data-stryd-ship]')) placeShip(footer);
        fixButtonTotal(footer);
      });
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

    return { update: update };
  })();

  /* ------------------------------------- test-mode notice (draft theme only) */

  var Notice = {
    show: function () {
      if (CFG.mode !== 'test' || CFG.isTester || document.querySelector('.stryd-test-banner')) return;
      var b = document.createElement('div');
      b.className = 'stryd-test-banner';
      b.innerHTML = '<b>Offers test mode</b><br>Bundle prices only apply when logged in as a test customer. <a href="/account/login" style="color:#fff">Log in</a>';
      document.body.appendChild(b);
    }
  };

  /* ---------------------------------------------- watch every cart change */

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var headers = (init && init.headers) || {};
    var ours = headers['X-Stryd-Offers'] || (headers.get && headers.get('X-Stryd-Offers'));
    var p = nativeFetch(input, init);
    if (!ours && /\/cart\/(add|change|update|clear)/.test(url)) {
      if (/\/cart\/change/.test(url)) watchGiftRemoval(init && init.body);
      p.then(function () { Gift.schedule(); }, function () {});
    }
    return p;
  };

  // a shopper's own remove on the gift line (cart drawer bin or qty 0) is the only thing that marks it declined
  function watchGiftRemoval(body) {
    try {
      var b = typeof body === 'string' ? JSON.parse(body) : null;
      if (!b) return;
      var variantId = String(b.id || b.line || '').split(':')[0];
      if (Number(b.quantity) === 0 && Gift.isGiftVariant(variantId)) Gift.markDeclined();
    } catch (e) {}
  }

  // XHR-based themes/apps
  var open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (/\/cart\/(add|change|update|clear)/.test(url || '')) {
      this.addEventListener('load', function () { Gift.schedule(); });
    }
    return open.apply(this, arguments);
  };

  // Essential Cart drawer: refresh after its own edits
  var tries = 0;
  (function hookEssential() {
    var api = window.essentialCartApi;
    if (api && api.onCartUpdate) { api.onCartUpdate(function () { Gift.schedule(); }); return; }
    if (tries++ < 20) setTimeout(hookEssential, 500);
  })();

  Gift.sync();
  window.StrydOffers = { sync: Gift.sync, addGift: Gift.addBack };
})();
